import classNames from 'classnames';
import dayjs from 'dayjs';
import { useCallback, useMemo } from 'react';
import { Icon } from 'tdesign-icons-react';
import { Button, Collapse, Textarea } from 'tdesign-react';
import FormItem from 'tdesign-react/es/form/FormItem';

import { DashBoard, EditorDel } from '@/components/icon';
import { INumSys, IRuleNum } from '@/interface/gamePlay';
import NumberSystemSelect from '@/pages/mission/info/card/event/customBranch/Branch/numberSystem/numberSysytemsSelect';

import GameTitle from '../title';
import styles from './index.module.less';

const { Panel } = Collapse;
interface IProps {
  disabled: boolean;
  value: INumSys;
  show: boolean;
  onChange: (val: INumSys) => void;
}
const defaultVal = {
  id: `${dayjs().valueOf()}`,
  numId: '',
  rule: '',
};
const NumSys: React.FC<IProps> = (props) => {
  const {
    disabled,
    value,
    show = false,
    onChange,
  } = props;

  const cards = useMemo(() => value?.rules || [defaultVal], [value?.rules]);


  const handleChange = (id: string, val: Partial<IRuleNum>) => {
    const result = cards.map((card) => {
      if (card.id === id) {
        return {
          ...card,
          ...val,
        };
      }
      return card;
    });
    onChange({
      ...value,
      rules: result,
    });
  };

  const handleAddCard = () => {
    const newCard: IRuleNum = {
      id: dayjs().valueOf() + cards?.length.toString(),
      numId: '',
      rule: '',
    };
    const result = [...cards, newCard];
    onChange({
      ...value,
      rules: result,
    });
  };

  // 删除卡片
  const handleDeleteCard = (id: string) => {
    const result = cards.filter(card => card.id !== id);
    onChange({
      ...value,
      rules: result,
    });
  };

  const formLabel = (title: string, subtitle?: string) => (
    <div className={styles.label} style={{ width: 120, marginRight: 110 }}>
      <div className={styles.labelTitle}>{title}</div>
      <div className={styles.subTitle}>{subtitle}</div>
    </div>);


  const panelHeader = useCallback((i: number) => (
    <div className={styles.panelHeader}>
      <div>{`数值规则${cards?.length > 1 ? i + 1 : ''}`}</div>
      <Button
        className={classNames(styles.delete, {
          'nova-disabled-opacity': disabled,
        })}
        disabled={disabled}
        theme="default"
        onClick={(e) => {
          e?.stopPropagation();
          handleDeleteCard(cards[i].id);
        }}
      >
        <EditorDel />
      </Button>
    </div>
  ), [disabled, cards]);

  return (
    <div className={styles.wrapper} style={show ? { display: 'flex' } : { display: 'none' }}>
      <GameTitle
        title="数值系统"
        subTitle='通过对话引起数值变动，触发新剧情'
        icon={<DashBoard />}
        fieldProps='numSys'
      />
      {
        cards?.map((e, i) => (
          <div className={styles.formCards} key={e?.id + i}>
            <Collapse
              defaultValue={['default']}
              expandIconPlacement={'right'}
            >
              <Panel header={panelHeader(i)} value="default">
                <>
                  <div>
                    <div className={styles.formItem}>
                      {formLabel('名称')}
                      <NumberSystemSelect
                        value={e?.numId}
                        disabled={disabled}
                        onChange={v => handleChange(e?.id, { numId: v as string })}
                      />
                    </div>
                    {!e?.numId && !disabled ? <div className={styles.errors}>请选择变量</div> : null}
                  </div>

                  <div>
                    <FormItem initialData={e?.rule} label="数值变化规则" labelAlign='top' >
                      <Textarea
                        disabled={disabled}
                        placeholder={'例如： 说出“你好”加5分，说出“谢谢”加10分，说出“再见”减5分'}
                        autosize={{ minRows: 5, maxRows: 5 }}
                        value={e?.rule}
                        onChange={v => handleChange(e?.id, { rule: v })} />
                    </FormItem>
                    {!e?.rule?.trim() && !disabled ? <div className={styles.errors}>请填写数值变化规则</div> : null}
                  </div>
                </>
              </Panel>
            </Collapse>
          </div>
        ))
      }
      {cards?.length === 0 && !disabled ? <div className={styles.errors}>请补充数值系统配置</div> : null}
      <div className={styles.addCard}>
        <Button
          theme="default"
          size='medium'
          style={{ width: '100%', height: 32 }}
          onClick={handleAddCard}
          icon={<Icon name="add" />}
          disabled={disabled}
        >
          新增
        </Button>
      </div>
    </div>
  );
};

export default NumSys;
